import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { TooltipDirective } from '@shared/components/tooltip';
import { ZendeskService } from '@shared/services/zendesk';

import { appWarning16Icon } from '@icons/px16/warning-16';

import { VersionsViewModel } from './versions.view-model';

@Component({
  selector: 'app-versions',
  templateUrl: './versions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent, TooltipDirective],
})
export class VersionsComponent {
  private readonly zendeskService = inject(ZendeskService);

  public readonly versions = input.required<VersionsViewModel>();
  public readonly showOnlyFeVersion = input.required<boolean>();

  public readonly isZendeskBubbleVisible = toSignal(this.zendeskService.isVisible$);

  constructor() {
    injectRegisterIcons([appWarning16Icon]);
  }
}
